<template>
  <div>
    <v-row class="grey darken-4 mx-0 rounded">
      <v-col cols="6" sm="3" md="2">
        <c-select
          :rotulo="$t('labels.opcoesBusca')"
          class="text-caption"
          itemText="label"
          itemValue="value"
          :clearable="false"
          :lista="options"
          @input="changeValue"
          :item.sync="searchFields.option"
        />
      </v-col>
      <v-col cols="6" sm="6" md="4">
        <v-text-field
          class="text-caption"
          persistent-hint
          outlined
          dense
          dark
          :label="$t('placeholders.termoBusca')"
          :maxlength="searchFields.option.maxLength"
          :placeholder="$t(`labels.${searchFields.option.value}`)"
          v-model="searchFields.text"
        />
      </v-col>
    </v-row>
    <index-buttons
      @search="sendSearch()"
      @register="openRegister()"
      @changeHeader="changeHeaderDialog = !changeHeaderDialog"
    />
    <v-row>
      <v-col cols="12">
        <megabit-table
          :tableItems="measurementUnitsList"
          :tableHeader="tableHeaderSelected"
          route="measurementUnits.register"
          :loading="loadingItems"
          :do-delete="doDelete"
          :itens-per-page="measurementUnitsList.length"
          :height="500"
        />
      </v-col>
    </v-row>
    <router-view />
    <change-header
      v-model="tableHeaderAvaiable"
      :showDialog="changeHeaderDialog"
      @close="changeHeaderDialog = !changeHeaderDialog"
      :name="headerName"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import MegabitTable from '@/components/shared/table/MegabitTable'
import cSelect from '@/components/shared/base-input/BaseSelect'
import IndexButtons from '@/components/shared/base-buttons/IndexButtons'
import { headerMixin } from '@/mixins/component/table/HeaderMixin'

export default {
  components: { MegabitTable, cSelect, IndexButtons },
  mixins: [headerMixin],
  data: () => {
    return {
      headerName: 'measurementUnitsIndex',
      query: { codigo: '', descricao: '', fator: '', page: 1 },
      textLabel: 'Código',
      searchFields: {
        option: { text: 'Código', value: 'codigo', maxLength: 3 },
        text: '',
      },
      tableHeaderAvaiable: [
        { label: 'codigo', text: 'Código', value: 'CODIGO', show: true },
        {
          label: 'descricao',
          text: 'Descricao',
          value: 'DESCRICAO',
          show: true,
        },
        { label: 'fator', text: 'Fator', value: 'FATOR', show: true },
        {
          label: 'acoes',
          text: 'Ações',
          value: 'controls',
          show: true,
          align: 'right',
        },
      ],
    }
  },
  computed: {
    ...mapState('measurementUnitsModule', [
      'pagination',
      'measurementUnitsList',
      'loadingItems',
    ]),
    options() {
      const header = [
        { label: 'Código', value: 'codigo', maxLength: 3 },
        { label: 'Descrição', value: 'descricao', maxLength: 18 },
        { label: 'Fator', value: 'fator', maxLength: 1 },
      ]
      return header.map((element) => {
        if (this.$te(`labels.${element.value}`))
          element.label = this.$t(`labels.${element.value}`)
        return element
      })
    },
  },
  methods: {
    ...mapActions({
      getAPI: 'measurementUnitsModule/getAPI',
      deleteAPI: 'measurementUnitsModule/deleteAPI',
    }),
    openRegister() {
      this.$router.push({ name: 'measurementUnits.register' })
    },
    async doDelete(item) {
      try {
        const response = await this.deleteAPI(item)
        this.$toasted.success(response)
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
    changeValue(item) {
      if (item) this.textLabel = this.searchFields.option.label
      else {
        this.textLabel = this.translatedOptions[0].label
        this.searchFields.option = this.translatedOptions[0]
      }
      this.searchFields.text = ''
    },
    async sendSearch() {
      try {
        let searchText = this.searchFields.text ?? ''
        let key = this.searchFields.option.value
        if (searchText.trim().length > 0 && key) {
          this.query[key] = searchText
        }

        await this.getAPI(this.query)
        this.cleanSearch()
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
    cleanSearch() {
      Object.keys(this.query).forEach((key) => {
        if (key !== 'page' && key !== 'todos') this.query[key] = ''
      })
    },

    async fetch() {
      try {
        await this.getAPI()
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
  },

  mounted() {
    this.fetch()
    this.mountHeader()
  },
}
</script>

<style></style>
